import { Component } from '@angular/core';

@Component({
  selector: 'app-brouillon-fac-f',
  templateUrl: './brouillon-fac-f.component.html',
  styleUrls: ['./brouillon-fac-f.component.scss']
})
export class BrouillonFacFComponent {}
